import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

const AboutAdmin = () => {
  const [form, setForm] = useState({
    badgeText: "",
    heading: "",
    description: "",
    heroImage: "",
    isActive: true
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const res = await api.get("/api/about");
        if (res.data) setForm(res.data);
      } catch (err) {
        console.error("ABOUT API ERROR:", err);
        setError("Failed to load About data");
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);

  if (loading) return <div>Loading About page...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  const save = async () => {
    try {
      await api.post("/api/about/about", form);
      alert("About Hero updated");
    } catch (err) {
      console.error("SAVE ERROR:", err);
      alert("Save failed");
    }
  };

  return (
    <div className="max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold">About Page – Hero Section</h1>

      {[
        ["Badge Text", "badgeText"],
        ["Heading", "heading"],
        ["Description", "description"],
        ["Hero Image URL", "heroImage"]
      ].map(([label, key]) => (
        <div key={key}>
          <label className="block text-sm font-medium mb-1">{label}</label>
          <input
            className="w-full border rounded p-2"
            value={form[key] || ""}
            onChange={(e) =>
              setForm({ ...form, [key]: e.target.value })
            }
          />
        </div>
      ))}

      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={form.isActive}
          onChange={(e) =>
            setForm({ ...form, isActive: e.target.checked })
          }
        />
        Active
      </label>

      <button
        onClick={save}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Save About Hero
      </button>
    </div>
  );
};

export default AboutAdmin;
